






























































































































































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AddIngresoNR from '@/components/ingresosNoReconocidos/AgregarIngresoNR.vue';
import AgregarPorCSV from '@/components/ingresosNoReconocidos/AgregarPorCSV.vue';
import firstCharsToUpperCase from '../util/firstCharsToUpperCase';
import CobroItem from '@/components/recibos/CobroItem.vue';
import UpdateIngreso from '@/components/ingresosNoReconocidos/UpdateIngreso.vue';

export default Vue.extend({
  components: { AddIngresoNR, AgregarPorCSV, CobroItem, UpdateIngreso },
  data: () => ({
    singleSelect: true,
    row: {},
    selected: [],
    selectedRecibo: [],
    headers: [
      { text: 'Unidad', value: 'unidad.name' },
      { text: 'Fecha', value: 'fecha' },
      { text: 'Monto', value: 'monto' },
      { text: 'Referencia', value: 'ref' },
      { text: 'Cuenta', value: 'cuenta.numCuenta' },
      { text: 'Disponible', value: 'openTotal' },
    ],
    headers1: [
      { text: 'Unidad', value: 'unidad.name', sortable: false, width: 150},
      { text: 'Periodo', value: 'periodo', sortable: false, width: 140},
      { text: 'Propietario', value: 'propietario.nombre', sortable: false, width: 150 },
      { text: 'tipo', value: 'tipoDeComprobante', width: 50 },
      { text: 'Serie', value: 'serie', width: 80},
      { text: 'Folio', value: 'folio', width: 85},
      { text: 'Subtotal', value: 'subtotal', width: 100 },
      { text: 'Total', value: 'total', width: 100 },
      { text: 'Status', value: 'pagoStatus', width: 50},
      { text: 'ADEUDO', value: 'openTotal', width: 100},
    ],
    pago: {
      monto: '',
      recibo: {},
      ingreso: {},
    },
    date: '',
    Pago: {},
    precision: 2,
    itemUnidad: [],
    itemPeriodo: [],
    itemPropietario: [],
    isSelectedUnique: false,
    isSelectedUniqueIncome: true,
    Recibos: [],
    total: 0,
    totalIng: 0,
    ingresos: [],
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 20,
      sortBy: ['unidad.name'],
      sortDesc: [false],
    },
    optionsR: {
      page: 1,
      itemsPerPage: 20,
      sortBy: '',
    },
    dialog: false,
    readonly: true,
    disponible: 0,
    filters: {
      propietario: '',
      periodo: '',
      unidad: '',
      idPropietario: null,
      idUnidad: null,
    },
    datos: {
      unidad: {},
      propietario: {},
    },
    result: {},
    ingresoNoRec: {},
    selectedIncome: [],
  }),
/*  mounted() {
  },*/
  methods: {
    open(event) {
      console.log('Current prueba:', event);
      if (event.unidad != null) {
        this.datos.unidad = event.unidad;
        console.log('Unidad: ', event.unidad.name);
      }
      this.loadData();
      this.Pago = event;
      this.getIngreso();
      this.dialog = true;
      this.readonly = true;
    },
    // rowSelected(event) {
      // this.open(event);
      // console.log("Recibo: %o, Ingreso: %o", this.selected, this.Pago);
    // },
    async getIngreso() {
      // async getIngreso(pago) {
      try {
        const adm = this.$store.getters.getAdmin;
        const cond = this.$store.getters.getCondo;
        const ingreso = this.Pago.id;
        this.loading = true;
        const result = await this.$store.dispatch('getIngresoById', {adm, cond, ingreso});
        console.debug('getIngresoById result: %o', result);
        this.disponible = result.openTotal;
        this.ingresoNoRec = result;
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    // async payRecibo() {
      // try {
      //   this.pago.recibo = this.selected;
      //   this.pago.ingreso = this.Pago;
      //   if (this.pago.monto > this.pago.ingreso.openTotal) {
      //     this.$toast.warning('El monto supera la cantidad del Ingreso');
      //     if (this.pago.monto > this.pago.recibo[0].openTotal) {
      //       this.$toast.warning('El monto supera la deuda de recibo');
      //       return;
      //     }
      //     return;
      //   } else {
      //     this.loading = true;
      //     this.result = await this.$store.dispatch('pagarRecibo', {datos: this.pago});
      //     console.debug('pagarRecibo result: %o', this.result);
      //   }
      // } catch (e) {
      //   console.error(e);
      //   this.$toast.error(e.response.data.message);
      // }
      // this.loading = false;
      // this.pago = {
      //   monto: '',
      //   recibo: {},
      //   ingreso: {},
      // };
      // this.loadData();
      // this.getIngreso();
    // },
    periodo(item) {
      const fecha = this.$moment(item.periodo).format('MMMM YYYY');
      return firstCharsToUpperCase(fecha);
    },
    fecha(item) {
      const fecha = this.$moment(item.fecha).format('DD-MM-YYYY');
      return firstCharsToUpperCase(fecha);
    },
    async getIngresos() {
      try {
        const adm = this.$store.getters.getAdmin;
        const cond = this.$store.getters.getCondo;
        this.loading = true;
        const result = await this.$store.dispatch('getIngresosList', {adm, cond, options: this.options});
        console.debug('getIngresosList result: %o', result);
        this.totalIng = result.totalElements;
        this.ingresos = result.content;
        console.log('ingresos no reconocidos: %o', this.ingresos);
        this.loading = false;
      } catch (e) {
        this.$toast.error(e);
      }
    },
    loadDataIncome() {
      this.getIngresos();
    },
    async loadData() {
      this.indexSelected++;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const options = this.optionsR;
      const datos = {admin, condo};
      const unidades = (this.itemUnidad.length === 0) ? (
              this.$store.dispatch('getUnidadesListMax', {datos, options})
              .then((result) => this.itemUnidad = result.content)
              .catch((e) => this.$toast.error(e))) : this.itemUnidad;
      const propietarios = (this.itemPropietario.length === 0) ? (
              this.$store.dispatch('getPropietCondoListMax', {admin, condo, options})
              .then((result) => this.itemPropietario = result.content)
              .catch ((e) => this.$toast.error(e))) : this.itemPropietario;
      const recibos = this.filter();
      Promise.all([unidades, propietarios, recibos])
        .then((values) => this.loading = false);
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadDataIncome();
    },
    async reloadGrid() {
      this.loadDataIncome();
      // this.getIngreso();
      // this.filter();
    },
    async reloadData() {
      // this.loadDataIncome();
      this.loadData();
      this.getIngreso();
    },
    filter() {
      (this.indexSelected === -1) ? (this.selected = [], this.options.page = 1) : this.indexSelected = -1;
      this.asigFilters();
      this.total = 0;
      this.Recibos = [];
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const filters = this.filters;
      const options = this.optionsR;
      // console.debug('OPTIONS %o', options);
      const datos = {admin, condo, options, filters};
      // console.debug('getRecibosList DATOS:%o', datos);
      const recibos = this.$store.dispatch('findUnidades', datos)
        .then((result) => { console.debug('getRecibosList RESPONSE: %o', result.content);
                            this.Recibos = result.content;
                            this.total = result.totalElements; })
        .catch((e) => {console.error(e);
                       this.$toast.error(e); });
      this.menuPeriodo = false;
      return recibos;
    },
    cleanDate() {
      this.date = '';
      this.menuPeriodo = false;
      this.filter();
    },
    asigFilters() {
      const filtro = this.datos.unidad;
      const filtroP = this.datos.propietario;
      // console.log('FECHA: ', this.date);
      (filtro != null) ? (this.filters.unidad = filtro.name,
                          this.filters.idUnidad = filtro.id)
                       : (this.filters.unidad = '',
                          this.filters.idUnidad = '');
      (filtroP != null) ? (this.filters.propietario = filtroP.nombre,
                           this.filters.idPropietario = filtroP.id)
                        : (this.filters.propietario = '',
                           this.filters.idPropietario = '');
      (this.date !== '') ? this.filters.periodo = this.$moment(this.date).format('YYYY-MM')
                         : this.filters.periodo = '';
    },
    closeDialog() {
      this.dialog = false;
      this.itemUnidad = [];
      this.selected = [];
      this.datos = {
        unidad: {},
        propietario: {},
      };
      this.loadDataIncome();
      // console.log('unidades: ', this.itemUnidad);
    },
  },
  watch: {
    selected() {
      if (Array.isArray(this.selected) && this.selected.length === 0) {
        this.ids = [];
        this.isSelectedEmpty = true;
        this.isSelectedUnique = false;
      } else {
        if (this.selected.length === 1) {
          this.isSelectedUnique = true;
        } else {
          this.isSelectedUnique = false;
        }
        let i = 0;
        this.ids = [];
        for (i = 0; i < this.selected.length; i++) {
          this.ids.push(this.selected[i].id);
        }
        // console.log('IDS: %o', this.ids);
        this.isSelectedEmpty = false;
      }
    },
    selectedIncome() {
      console.log('Is Selected Empty: ', this.selectedIncome);
      if (this.selectedIncome.length === 1) {
        console.log('if cumplido');
        this.isSelectedUniqueIncome = false;
      } else {
        console.log('if no cumplido');
        this.isSelectedUniqueIncome = true;
      }
    },
  },
  computed: {
    computedDateFormatted() {
      if (this.date !== '') {
        const fecha = {periodo: '' };
        fecha.periodo = this.$moment(this.date).format();
        return this.periodo(fecha);
      } else {
        this.date = '';
        return this.date;
      }
    },
  },
});
